// PERFORMANCE MONITORING UTILITY
// Helps track and log performance metrics in development

class PerformanceMonitor {
  constructor() {
    this.metrics = new Map();
    this.enabled = process.env.NODE_ENV === 'development';
  }

  startMeasure(label) {
    if (!this.enabled) return;
    this.metrics?.set(label, performance.now());
  }

  endMeasure(label) {
    if (!this.enabled) return;
    
    const startTime = this.metrics?.get(label);
    if (!startTime) {
      console.warn(`No start time found for measure: ${label}`);
      return;
    }

    const endTime = performance.now();
    const duration = endTime - startTime;
    
    console.log(`⚡ ${label}: ${duration?.toFixed(2)}ms`);
    this.metrics?.delete(label);
    
    return duration;
  }

  measureAsync(label, asyncFn) {
    if (!this.enabled) return asyncFn();

    return new Promise(async (resolve, reject) => {
      this.startMeasure(label);
      try {
        const result = await asyncFn();
        this.endMeasure(label);
        resolve(result);
      } catch (error) {
        this.endMeasure(label);
        reject(error);
      }
    });
  }

  logComponentRender(componentName) {
    if (!this.enabled) return;
    console.log(`🔄 ${componentName} rendered at ${new Date()?.toISOString()}`);
  }
}

export const performanceMonitor = new PerformanceMonitor();

// Hook for component render tracking
export const useRenderLog = (componentName) => {
  if (process.env.NODE_ENV === 'development') {
    performanceMonitor?.logComponentRender(componentName);
  }
};